import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import FormYearMonth from '../components/form-year-month';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { CourseModel, SignupModelHelper } from "../data/SignupModel";
import { dataLayerHelper } from "../data/dataLayerModel";
import { months } from '../data/months';
import AmarelinhoService from '../services/AmarelinhoService';

export default function CursosInicio(props: any) {

  const [interactions, setInteractions] = useState<InteractionModel[]>([]);
  const [course, setCourse] = useState<CourseModel | null>(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    TagManager.dataLayer(dataLayerHelper.pagina('inicio-ano', 'cursos'));
    setCourse(SignupModelHelper.getOngoingCourse());
  }, [])

  function setEntranceYearMonth(yearMonth: string) {
    const [year] = yearMonth.split('-');
    const startDate = new Date(yearMonth + '-01T12:00');
    const today = new Date();
    today.setHours(12);
    const maxYear = new Date().getFullYear();

    const chat = [...interactions, {
      text: `${months[startDate.getMonth()]} de ${startDate.getFullYear()}`,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);

    if (isNaN(+year) || +year < 1900) {
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Informe um ano entre 1900 e ${maxYear}`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (startDate > today) {
      setTimeout(() => {
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Selecione um mês anterior a ${months[nextMonth.getMonth()]} de ${nextMonth.getFullYear()}.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    }
    else { // valid start date

      SignupModelHelper.updateCourse({ start: startDate });

      if (course?.current) {
        const signup = SignupModelHelper.updateCourse({ saved: true });
        if (signup) {
          setLoading(true)
          AmarelinhoService.saveCourses(signup).then((ret) => {
            setLoading(false);
            if (!ret.success) {
              setTimeout(() => {
                setInteractions([...chat, {
                  author: InteractionAuthor.AMARELINHO,
                  text: ret.message!
                }]);
                setTimeout(() => {
                  let chat = document.getElementsByClassName('chat')[0];
                  chat.scrollTo(0, chat.scrollHeight);
                }, 500);
              }, 1000)
            } else {
              TagManager.dataLayer(dataLayerHelper.formEnviado('form_escolaridade'));
              SignupModelHelper.update({ courses: undefined });
              document.location = '#/idiomas-inicio';
            }
          })
        }

      } else {
        document.location = '#/cursos-fim';
      }
    }
  }

  return (
    <>
      <Header step={ 7 } total={ 8 } title="Cursos" previous="#/cursos-ainda-estuda"></Header>

      <FormYearMonth
        lastAnswer={ course?.current === true ? 'Sim, estou cursando.' : 'Não, já terminei.' }
        question="Então, me conta <strong>quando você começou</strong>."
        interactions={ interactions }
        loading={ loading }
        onSubmit={ setEntranceYearMonth }
      />
    </>);
}
